module.exports = __webpack_public_path__ + "assets/img/3.c00c83fd.png";